import { HeaderImageColumn } from '../image-column'
import { HeaderLinkColumn } from '../link-column'
import { Link } from '@gassan-ui'
import { WeddingRingsContent } from '@lib/kontent/navigation-helpers/get-wedding-rings-content'
import NextLink from 'next/link'
import { FC } from 'react'

type HeaderShopMenuRingsProps = WeddingRingsContent

export const HeaderShopMenuRings: FC<HeaderShopMenuRingsProps> = ({
  linkList,
  imageLinkFirstColumn,
  imageLinkSecondColumn,
}) => {
  return (
    <>
      <HeaderLinkColumn
        title={linkList.title}
        readMoreLink={
          linkList.viewMore && (
            <NextLink href={linkList.viewMore.url} passHref>
              <Link variant="blue">{linkList.viewMore.label}</Link>
            </NextLink>
          )
        }
        links={linkList.links}
        linkSpace="regular"
      />
      <HeaderImageColumn {...imageLinkFirstColumn} />
      <HeaderImageColumn {...imageLinkSecondColumn} showOnlyOnXlarge />
    </>
  )
}
